import React, { ReactNode } from 'react';
import { GREY_B } from 'app/constants/Colors';
import { useCss } from 'app/utils/css';

interface ISettingsSectionProps {
  title: string;
  // Used for media section headers
  preview?: ReactNode;
}

const SettingsSection: React.FunctionComponent<ISettingsSectionProps> = ({ title, preview, children }) => {
  const css = useCss();

  return (
    // TODO: Consider removing external margin here, which imposes style on outer layout
    <div className={css('section', { margin: '1.5em 0' })}>
      <div
        className={css('header', {
          marginBottom:   '0.5em',
          display:        'flex',
          justifyContent: 'space-between',
          alignItems:     'flex-start',
        })}
      >
        <div className={css('title', { fontSize: '1.2em', color: GREY_B })}>{title}</div>
        {preview &&
          <div
            className={css('preview', {
              width:     '40%',
              maxWidth:  '150px',
              maxHeight: '100px',
              position:  'relative',
            })}
          >
            {preview}
          </div>}
      </div>

      {children}
    </div>
  );
};

export default SettingsSection;
